/**
 * /devhub/audit — Area F4 (Audit & Logs). REQ-001.91 DevHub UI rebuild · Phase 1 IA shell.
 * Replaces the old disabled "Audit & logs" nav stub with a real route.
 */
import { createFileRoute } from '@tanstack/react-router';

import { DevHubAreaShell } from '../components/devhub/DevHubAreaShell';

export const Route = createFileRoute('/devhub/audit')({ component: DevHubAudit });

function DevHubAudit() {
  return (
    <DevHubAreaShell
      title="Audit & Logs"
      subtitle="Unified operator audit over traces, ActionFrames and approvals, with the honest readiness verdict."
      pages={[
        { label: 'Evidence packs', description: 'Audit evidence bundles per requirement and gate.', status: 'live', to: '/devhub/evidence' },
        { label: 'Unified audit', description: 'Traces + frames + approval_events (live /api/control/*).', status: 'Phase 2' },
        { label: 'Readiness verdict', description: 'beta_readiness_gate.json tile — currently not_ready_major_gaps.', status: 'Phase 2' },
      ]}
    />
  );
}
